import { Box, Slider, Typography } from '@mui/material';
import React from 'react';
import { BRIGHTNESS_MIN, BRIGHTNESS_MAX } from '../constants';

export interface BrightnessControlsProps {
  brightness: number;
  onBrightnessChange: (brightness: number) => void;
}

export const BrightnessControls = ({
  brightness,
  onBrightnessChange,
}: BrightnessControlsProps) => {
  return (
    <Box>
      <Typography
        color="white"
        sx={{ display: { xs: 'none', md: 'block' }, mt: 1 }}
      >
        Brightness
      </Typography>
      <Slider
        value={brightness}
        onChange={(_, val) => onBrightnessChange(val as number)}
        min={BRIGHTNESS_MIN}
        max={BRIGHTNESS_MAX}
        sx={{ color: 'white', width: 200 }}
      />
    </Box>
  );
};
